<template lang="pug">
    header
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
        .logo(:style="{'is-shop': view == 'Preorder'}")
            router-link(to="/")
                component(
                    @mouseover="showMenuOnLandingpage"
                    @mouseleave="hideMenuOnLandingpage"
                    :is="logo.component"
                    v-html="logo.html"
                )
</template>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Header',
    computed: {
        ...mapGetters({
            sidebar: 'sidebar',
            logo: 'currentPage/logo',
            subtitle: 'currentPage/subtitle',
            view: 'currentPage/view'
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        }),
        ...mapActions({
            showMenuOnLandingpage: 'currentPage/showMenuOnLandingpage',
            hideMenuOnLandingpage: 'currentPage/hideMenuOnLandingpage',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    header
        width: 100%
        z-index: 999
        top: 0
        margin-bottom: 12vh
        +desktop
            margin-bottom: 0
        .hamburger
            height: 45px
            padding: 10px
            outline: none
            +desktop
                display: none
        .logo ::v-deep
            text-align: center
            font-weight: 600
            line-height: 1.2
            // margin-top: 20vh
            min-height: 20vh
            display: flex
            justify-content: center
            align-items: flex-end
            +desktop
                // margin-top: 30vh
                min-height: 30vh
            h1
                font-size: 2.1rem
                font-weight: 600
                letter-spacing: .3rem
            h2
                font-size: 1.35rem
                font-weight: 600
</style>
